module.exports = __webpack_public_path__ + "static/media/icon_checkin_active.c3478876.svg";